








import { Component, Mixins, Prop } from "vue-property-decorator";
import DateObject from "../objects/DateObject.vue";

@Component
export default class FixedDateMenu extends Mixins() {
  @Prop()
  source: DateObject;

  @Prop()
  phrase: string;

  get description(): string {
    return (this.phrase + "を入力します。");
  }

  async overwrite(): Promise<void> {
    this.source.overwriteDate(this.phrase);
  }
}
